/**
 * DEV-022 · Role identity resolver.
 *
 * Maps an authenticated user's `role` to its portal identity so
 * every shell / hero / eyebrow reads the SAME label consistently.
 * Prevents the "Sales user seeing 'Operations Portal'" bug the
 * portal-wide redesign explicitly calls out.
 *
 * No API / schema changes — presentation-only.
 */
export function portalIdentity(role) {
    switch (role) {
        case "sales":
            return {
                key: "sales",
                label: "Sales",
                portalLabel: "Sales Portal",
                eyebrow: "SALES PORTAL",
                topbarLabel: "Sales",
                homePath: "/sales",
            };
        case "installer":
            return {
                key: "installer",
                label: "Field",
                portalLabel: "Field Portal",
                eyebrow: "FIELD PORTAL",
                topbarLabel: "Field",
                homePath: "/installer",
            };
        case "customer":
            return {
                key: "customer",
                label: "Customer",
                portalLabel: "Customer Portal",
                eyebrow: "CUSTOMER PORTAL",
                topbarLabel: "Customer",
                homePath: "/dashboard",
            };
        case "operations":
        default:
            return {
                key: "operations",
                label: "Operations",
                portalLabel: "Operations Portal",
                eyebrow: "OPERATIONS PORTAL",
                topbarLabel: "Operations",
                homePath: "/operations",
            };
    }
}
